import Boom from '@hapi/boom'
import _ from 'lodash'

const PASSWORD_TEST_FUNCTIONS = [
  (password) => password.length >= 8,
  (password) => /[A-Z]/.test(password),
  (password) => /[0-9]/.test(password),
  (password) => /[^A-Za-z0-9]/.test(password),
  (password) => /[a-z]/.test(password),
  (password) => !/(.)\1{2,}/.test(password),
]

const PASSPHRASE_TEST_FUNCTIONS = [
  (password) => password.length >= 20,
  (password) => !/(.)\1{2,}/.test(password),
]

function testIsPassphrase(password) {
  return PASSPHRASE_TEST_FUNCTIONS[0](password)
}

export const PASSWORD_REQUIREMENTS_MESSAGES = [
  'At least 8 characters',
  'An UPPERCASE character',
  'A number',
  'A special character (examples: !, %, #, $, &)',
  'A lowercase character',
  'No more than three consecutive instances of any one character',
]

export const PASSPHRASE_REQUIREMENTS_MESSAGES = [
  'Minimum 20 characters',
  'No more than three consecutive instances of any one character',
]

export const PASSWORD_STRENGTH_EMPTY_RESULT = {
  tests: [],
  testsPassphrase: [],
  isStrong: false,
  isPassphrase: false,
}

export function testPassword(password): {
  tests: Array<boolean>,
  testsPassphrase: Array<boolean>,
  isStrong: boolean,
  isPassphrase: boolean,
} {
  if (typeof password !== 'string') {
    return PASSWORD_STRENGTH_EMPTY_RESULT
  }

  const tests = PASSWORD_TEST_FUNCTIONS.map((func) => {
    return func(password)
  })
  const testsPassphrase = PASSPHRASE_TEST_FUNCTIONS.map((func) => {
    return func(password)
  })
  const isPassphrase = testIsPassphrase(password)
  const isStrong = (isPassphrase ? testsPassphrase : tests).reduce(
    (res, bool) => (!bool ? bool : res),
    true,
  )

  return {
    tests,
    testsPassphrase,
    isStrong,
    isPassphrase,
  }
}

/**
 *
 * @param password
 * @param email
 *
 * @throws Boom
 */
export function checkPasswordIsNotEqualToEmail(
  password: string,
  email: string,
) {
  if (_.toLower(password) === _.toLower(email)) {
    throw Boom.badRequest('You cannot use your email ID as your password.')
  }
}
